export default "__VITE_ASSET__BIgGTYU___"